import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useStateMachine } from 'little-state-machine';
import updateAction from '../../updateAction';
import { Dialog } from '@reach/dialog';
import ModalFAQs from '../../components/ModalFAQs';
import Accordion from '../../components/Accordion';

import BackButton from '../../components/BackButton';
import Button from '../../components/Button';
import Disclaimer from '../../components/Disclaimer';
import RadioGroup from '../../components/RadioGroup';
import StackForm from '../../components/StackForm';
import Title from '../../components/Title';
import OfferOption from '../../components/OfferOption';
import BannerCuenta from '../../components/BannerCuenta';
import BannerTarjeta from '../../components/BannerTarjeta';

import { NO_TIENE_CUENTA_MESSAGE, NO_ES_CLIENTE_MESSAGE, LANDING_URL } from '../../config';
import { getNumberWithDots } from '../../helpers';
import { useGlobalData } from '../../../store';
import {
  amortizable_step2,
  tc_step2,
  sobregiro_step2,
  nextStep_step2,
  loadStep2,
  loginModal,
} from '../../analytics';

const Offers = props => {
  const [modal, setModal] = useState(false);
  const { setGlobalData, globalData } = useGlobalData();
  const { register, errors, handleSubmit } = useForm({
    mode: 'onBlur',
  });
  const { action, state } = useStateMachine(updateAction);

  const isPersonalBank = globalData?.tipoPaquete === 'P' || false;

  useEffect(() => {
    loadStep2();
  }, []);

  const onSubmit = data => {
    loginModal();
    document.querySelector('.progress-indicator').style.width = '100%';
    action(data);

    if (window.openModal) {
      window.openModal();
    } else {
      console.error('Falta la ventana modal de Inicio de Sesión.');
    }
  };

  const noTieneCuenta = state?.data?.tipo_cuenta?.includes('tipo_cuenta-no') || false;
  const noTieneTarjeta = state?.data?.tarjeta?.includes('tarjeta-no') || false;

  const renderOffers = () => {
    if (noTieneCuenta) {
      if (noTieneTarjeta) {
        return <Disclaimer message={NO_ES_CLIENTE_MESSAGE} />;
      } else {
        return <Disclaimer message={NO_TIENE_CUENTA_MESSAGE} />;
      }
    }

    const response = state?.data?.response;

    const {
      tasas_prestamos_TC,
      tasas_prestamos_personales,
      tasas_sobregiros,
      solicitud_original,
    } = response;

    const monedaSolicitada = solicitud_original?.moneda; // URGP || US.D
    let monedaSimbolo;

    switch (monedaSolicitada) {
      case 'URGP':
        monedaSimbolo = '$ ';
        break;
      case 'US.D':
        monedaSimbolo = 'U$S ';
        break;
      default:
        monedaSimbolo = '';
        break;
    }

    let personalOptions = [];

    tasas_prestamos_personales.forEach((tasa, i) => {
      personalOptions.push({
        value: tasa.plazo,
        id: 'option-personal-' + i,
        component: (
          <OfferOption
            installments={tasa.plazo}
            price={monedaSimbolo + getNumberWithDots(tasa.monto_cuota)}
            total={monedaSimbolo + getNumberWithDots(tasa.monto_total)}
            rate={tasa.interes + '%'}
            isPersonalBank={isPersonalBank}
          />
        ),
      });
    });

    let tarjetaOptions = [];

    tasas_prestamos_TC.forEach((tasa, i) => {
      tarjetaOptions.push({
        value: tasa.plazo,
        id: 'option-tarjeta-' + i,
        component: (
          <OfferOption
            installments={tasa.plazo}
            price={monedaSimbolo + getNumberWithDots(tasa.monto_cuota)}
            total={monedaSimbolo + getNumberWithDots(tasa.monto_total)}
            rate={tasa.interes + '%'}
            isPersonalBank={isPersonalBank}
          />
        ),
      });
    });

    let sobregiroOptions = [];

    tasas_sobregiros.forEach((tasa, i) => {
      sobregiroOptions.push({
        value: 'option-sobregiro-' + i,
        id: 'option-sobregiro-' + i,
        component: (
          <OfferOption
            single={monedaSimbolo + getNumberWithDots(tasa.monto_total)}
            total="Sobregiro en cuenta"
            rate={tasa.interes + '%'}
            isPersonalBank={isPersonalBank}
          />
        ),
      });
    });

    const haySobregiros = tasas_sobregiros.length > 0;
    const hayPrestamosTC = tasas_prestamos_TC.length > 0;
    const hayPrestamosPersonales = tasas_prestamos_personales.length > 0;

    return (
      <>
        {(haySobregiros && !hayPrestamosTC && !hayPrestamosPersonales) ||
        (!haySobregiros && hayPrestamosTC && !hayPrestamosPersonales) ||
        (!haySobregiros && !hayPrestamosTC && hayPrestamosPersonales) ? (
          <>
            {tasas_prestamos_personales?.length > 0 && (
              <div className="options-container">
                <div className="options-subtitle">Préstamo amortizable</div>
                <p className="options-copy">
                  T.E.A desde 49%, te damos un crédito contra el disponible de tu tarjeta de crédito
                  y las cuotas se debitan de tu tarjeta.
                </p>

                <RadioGroup
                  type="card"
                  name="plazo"
                  options={personalOptions}
                  register={register({ required: 'Debe seleccionar una oferta para continuar.' })}
                  error={errors.plazo}
                  isPersonalBank={isPersonalBank}
                  onChange={e => {
                    const plazo = e.target.value;
                    action({ plazo });
                    setGlobalData({ plazo, title: 'amortizable' });
                    if (window.setDeeplink) {
                      window.setDeeplink('prestamo_preaprobado');
                    }
                  }}
                />
                <p className="options-more">
                  Ver{' '}
                  <button
                    onClick={e => {
                      e.preventDefault();
                      setModal(true);
                    }}
                  >
                    más información
                  </button>{' '}
                  de este producto
                </p>
              </div>
            )}

            {tasas_prestamos_TC?.length > 0 && (
              <div className="options-container">
                <div className="options-subtitle">Préstamo en Tarjeta de Crédito</div>
                <p className="options-copy">
                  T.E.A desde 49%, te damos un crédito contra el disponible de tu tarjeta de crédito
                  y las cuotas se debitan de tu tarjeta.
                </p>

                <RadioGroup
                  type="card"
                  name="plazo"
                  options={tarjetaOptions}
                  register={register({ required: 'Debe seleccionar una oferta para continuar.' })}
                  error={errors.plazo}
                  isPersonalBank={isPersonalBank}
                  onChange={e => {
                    const plazo = e.target.value;
                    action({ plazo });
                    setGlobalData({ plazo, title: 'tarjeta' });
                    if (window.setDeeplink) {
                      window.setDeeplink('tarjeta_credito');
                    }
                  }}
                />
                <p className="options-more">
                  Ver{' '}
                  <button
                    onClick={e => {
                      e.preventDefault();
                      setModal(true);
                    }}
                  >
                    más información
                  </button>{' '}
                  de este producto
                </p>
              </div>
            )}

            {tasas_sobregiros?.length > 0 && (
              <div className="options-container">
                <div className="options-subtitle">Sobregiro en cuenta</div>
                <p className="options-copy">
                  Podés usar el crédito cuando tu cuenta está en cero. Los intereses se calculan por
                  día y se cobran a fin de mes.
                </p>
                <RadioGroup
                  type="card"
                  name="plazo"
                  options={sobregiroOptions}
                  isPersonalBank={isPersonalBank}
                  register={register({ required: 'Debe seleccionar una oferta para continuar.' })}
                  error={errors.plazo}
                  onChange={e => {
                    const plazo = e.target.value;
                    action({ plazo });
                    setGlobalData({ plazo: '-', title: 'sobregiro' });
                    if (window.setDeeplink) {
                      window.setDeeplink('prestamo_preaprobado');
                    }
                  }}
                />
                <p className="options-more">
                  Ver{' '}
                  <button
                    onClick={e => {
                      e.preventDefault();
                      setModal(true);
                    }}
                  >
                    más información
                  </button>{' '}
                  de este producto
                </p>
              </div>
            )}
          </>
        ) : (
          <div className="group-accordions">
            {tasas_prestamos_personales?.length > 0 && (
              <Accordion
                title="Préstamo amortizable"
                copy="Se acredita en tu cuenta y las cuotas se debitan cada mes en la fecha que vos elijas."
                onClick={() => amortizable_step2()}
              >
                <RadioGroup
                  type="card"
                  isPersonalBank={isPersonalBank}
                  name="plazo"
                  options={personalOptions}
                  register={register({ required: 'Debe seleccionar una oferta para continuar.' })}
                  error={errors.plazo}
                  onChange={e => {
                    const plazo = e.target.value;
                    action({ plazo });
                    setGlobalData({ plazo, title: 'amortizable' });
                    if (window.setDeeplink) {
                      window.setDeeplink('prestamo_preaprobado');
                    }
                  }}
                />
                <p className="options-more">
                  Ver{' '}
                  <button
                    onClick={e => {
                      e.preventDefault();
                      setModal(true);
                    }}
                  >
                    más información
                  </button>{' '}
                  de este producto
                </p>
              </Accordion>
            )}

            {tasas_prestamos_TC?.length > 0 && (
              <Accordion
                title="Préstamo en Tarjeta de Crédito"
                copy="Te damos un crédito contra el disponible de tu tarjeta de crédito y las cuotas se debitarán cada mes de tu tarjeta de crédito."
                onClick={() => tc_step2()}
              >
                <RadioGroup
                  type="card"
                  name="plazo"
                  isPersonalBank={isPersonalBank}
                  options={tarjetaOptions}
                  register={register({ required: 'Debe seleccionar una oferta para continuar.' })}
                  error={errors.plazo}
                  onChange={e => {
                    const plazo = e.target.value;
                    action({ plazo });
                    setGlobalData({ plazo, title: 'tarjeta' });
                    if (window.setDeeplink) {
                      window.setDeeplink('tarjeta_credito');
                    }
                  }}
                />
                <p className="options-more">
                  Ver{' '}
                  <button
                    onClick={e => {
                      e.preventDefault();
                      setModal(true);
                    }}
                  >
                    más información
                  </button>{' '}
                  de este producto
                </p>
              </Accordion>
            )}

            {tasas_sobregiros?.length > 0 && (
              <Accordion
                title="Sobregiro en cuenta"
                copy="Podés usar el crédito cuando tu cuenta está en cero. Los intereses se calculan por día y se cobran a fin de mes."
                onClick={() => sobregiro_step2()}
              >
                <RadioGroup
                  type="card"
                  name="plazo"
                  isPersonalBank={isPersonalBank}
                  options={sobregiroOptions}
                  register={register({ required: 'Debe seleccionar una oferta para continuar.' })}
                  error={errors.plazo}
                  onChange={e => {
                    const plazo = e.target.value;
                    action({ plazo });
                    setGlobalData({ plazo: '-', title: 'sobregiro' });
                    if (window.setDeeplink) {
                      window.setDeeplink('prestamo_preaprobado');
                    }
                  }}
                />
                <p className="options-more">
                  Ver{' '}
                  <button
                    onClick={e => {
                      e.preventDefault();
                      setModal(true);
                    }}
                  >
                    más información
                  </button>{' '}
                  de este producto
                </p>
              </Accordion>
            )}
          </div>
        )}
      </>
    );
  };

  const getTitle = () => {
    let title;

    if (noTieneCuenta) {
      if (noTieneTarjeta) {
        title = 'Ups, no sos cliente Itaú.';
      } else {
        title = 'Ups, no tenés cuenta Itaú.';
      }
    } else {
      title = 'Elegí el tipo de préstamo que más se adapte a ti';
    }

    return title;
  };

  return (
    <StackForm onSubmit={handleSubmit(onSubmit)}>
      <div>
        <Title>{getTitle()}</Title>

        {renderOffers()}

        {/* Si no tiene cuentas */}
        {noTieneCuenta && <BannerCuenta />}

        {/* Si no tiene Tarjeta */}
        {noTieneTarjeta && <BannerTarjeta />}
      </div>

      <div className="form-actions">
        {noTieneCuenta && noTieneTarjeta ? (
          <Button href={LANDING_URL} block id="pp_siguiente_3">
            terminar
          </Button>
        ) : (
          <Button type="submit" block id="pp_siguiente_3" onClick={() => nextStep_step2()}>
            lo quiero ya
          </Button>
        )}

        <BackButton />
      </div>

      <Dialog isOpen={modal} onDismiss={() => setModal(false)} aria-label="Información adicional">
        <ModalFAQs onDismiss={() => setModal(false)} defaultTab={0} />
      </Dialog>

      <style jsx global>{`
        .options-subtitle {
          font-weight: bold;
          font-size: 18px;
          color: #56504c;
          margin-bottom: 0;
        }

        .options-copy {
          font-family: 'ItauText', sans-serif;
          font-weight: bold;
          font-size: 12px;
          line-height: 20px;
          color: #56504c;
          margin-bottom: 0;
          font-weight: 400;
          margin-top: 0;
          max-width: calc(100% - 118px);
          margin-bottom: 16px;
        }

        .options-subtitle + :global(.banner) {
          margin-top: 10px;
        }

        .options-more {
          font-size: 15px;
          color: #757575;
          margin-bottom: 24px;
          margin-top: 0;
        }

        .options-more button {
          font: inherit;
          padding: 0;
          border: 0;
          background: transparent;
          cursor: pointer;
          color: #106eb0;
          text-decoration: none;
        }

        .options-more button:hover {
          text-decoration: underline;
        }

        .options-container {
          margin-top: 16px;
        }

        .group-accordions {
          margin-bottom: 24px;
        }

        .radio-group {
          margin-bottom: 16px !important;
        }
      `}</style>
    </StackForm>
  );
};

export default withRouter(Offers);
